import { memo, PropsWithChildren } from "react";
import classNames from "classnames";
import "./panel.scss";

interface PanelProps extends PropsWithChildren {
  className?: string;
  role?: string;
  id?: string;
  tabIndex?: number;
  onClick?: () => void;
  noBorder?: boolean;
  hidden?: boolean;
  style?: React.CSSProperties;
  ref?: React.Ref<HTMLDivElement>;
  model?: "bordered" | "elevated" | "flat";
  selected?: boolean;
  themeColor?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "default"
    | "light"
    | "dark";
}

const PanelComponent = ({
  role,
  className = "",
  children,
  noBorder,
  hidden,
  model,
  ref,
  themeColor,
  selected,
  ...restProps
}: PanelProps) => {
  return (
    <div
      className={classNames("panel-container", className, model, {
        hover: role === "button",
        "no-border": noBorder,
        hidden,
        [`border-${themeColor}`]: themeColor,
        default: !themeColor,
        [`bg-${themeColor}`]: selected && themeColor,
      })}
      ref={ref}
      {...restProps}
    >
      {children}
    </div>
  );
};

PanelComponent.displayName = "PanelComponent";

export const Panel = memo(PanelComponent);
export { PanelBody } from "./panel-body";
export { PanelFooter } from "./panel-footer";
export {
  PanelHeader,
  PanelActionArea,
  PanelDescription,
  PanelTitle,
  PanelTitleArea,
  PanelSubTitle,
} from "./panel-header";
